import { FormattedMessage } from 'react-intl'
import UrgencyLabel from 'LuxKit/Label/UrgencyLabel'
import clsx from 'clsx'
import useHasMounted from 'hooks/useHasMounted'
import useExperiment from 'hooks/Experiments/useExperiment'
import { Experiments } from 'constants/experiments'
interface Props {
  availableRoomCount: number
}

function OfferUrgencyRoomCount(props: Props) {
  const {
    availableRoomCount,
  } = props

  const hasMounted = useHasMounted()

  const { isAnyVariant: croPopularOptionBookingRemaining } = useExperiment(Experiments.croPopularOptionBookingRemaining)
  if (!croPopularOptionBookingRemaining) {
    return null
  }

  return <UrgencyLabel
    className={clsx({ 'not-mounted': !hasMounted })}
    variant="critical2"
  >
    <FormattedMessage
      id="3pACN79zGCSmwcWeVmPY"
      defaultMessage="Guest favourite – {count, plural, one {# room} other {# rooms}} left"
      description="Urgency label showing limited room availability on offer card"
      values={{ count: availableRoomCount }}
    />
  </UrgencyLabel>
}

export default OfferUrgencyRoomCount
